// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--1LmaL","header__nav":"header-module--header__nav--2cr1F","header__title":"header-module--header__title--25ZGV"};